/* eslint-disable max-len */
import { Navigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { type StandardApplicationEntrypointContextDataFragment } from '../../../../api/fragments/StandardApplicationEntrypointContextData';
import { type StandardApplicationPublicAccessEntrypointContextDataFragment } from '../../../../api/fragments/StandardApplicationPublicAccessEntrypointContextData';
import { type Maybe } from '../../../../api/types';
import { useSingleDealerId } from '../../../../components/contexts/DealerContextManager';
import ComparisonCalculatorStage from './ComparisonCalculatorStage';

type ComparisonLocationState = {
    vehicleIds: string[];
};

export type ComparisonPageProps = {
    endpoint:
        | StandardApplicationEntrypointContextDataFragment
        | StandardApplicationPublicAccessEntrypointContextDataFragment;
};

const ComparisonPage = ({ endpoint }: ComparisonPageProps) => {
    const state = useLocation().state as Maybe<ComparisonLocationState>;

    // For private comparison page
    // Dealer selection is on the left sidebar, which only allow one dealer to be selected
    const { dealerId } = useSingleDealerId();

    if (!state || !state.vehicleIds?.length) {
        return <Navigate to=".." replace />;
    }

    return (
        <ComparisonCalculatorStage
            dealerIds={dealerId ? [dealerId] : []}
            endpoint={endpoint}
            vehicleIds={state?.vehicleIds || []}
        />
    );
};

export default ComparisonPage;
